import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdownContentList = function (props) {
    var groups = props.groups, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-v2", { ref: ref, groups: groups ? (typeof groups === 'object' ? JSON.stringify(groups) : groups) : undefined }, children));
};
export default VeltCommentsSidebarV2FilterDropdownContentList;
